export const getListOfLessonsId = (modules) => {
  return modules
    ?.map((module) => module?.lessons?.map((lesson) => lesson?.id))
    .flat(Infinity);
};
